#import "../fragments/availability-fragment.graphql"

mutation SetAvailability($input: AvailabilitySetInput!) {
    availabilitySet(input: $input) {
        availability {
            ...AvailabilityFragment
        }
    }
}
